import PropTypes from 'prop-types'

export default PropTypes.shape({
  imoNumber: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
})
